import { AnonymousCartMetaStoreType } from "UidispatcherApiModule";
const { AnonymousCartMetaStore }: { AnonymousCartMetaStore: AnonymousCartMetaStoreType } =
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore
    await import("uidispatcher_api/UidispatcherApiModule");
export { AnonymousCartMetaStore };
